import { useEnabledFeatures } from '~/common/hooks/enabled-features';
import { useDexMetadata } from './use-dex-metadata';
import { useShowDexDeviceIdentificationError } from './use-show-dex-device-identification-error';

/**
 * Determines whether the current user is allowed to access DEX (Data Exchange) features.
 *
 * Access is granted only when all required prerequisites are satisfied:
 * - The `dataExchange` feature flag is enabled
 * - DEX metadata is fully loaded
 * - No DIS errors are present
 *
 * @returns {{
 *   isDexEnabled: boolean;
 *   isLoading: boolean;
 * }}
 */

export function useIsDexEnabled(): {
    isDexEnabled: boolean;
    isLoading: boolean;
} {
    const { dataExchange } = useEnabledFeatures();
    const isDexDeviceIdentificationError = useShowDexDeviceIdentificationError();
    const { isLoading } = useDexMetadata();

    const isDexEnabled =
        !!dataExchange &&
        !isLoading &&
        !isDexDeviceIdentificationError;

    return { isDexEnabled, isLoading };
}

